import Footer from "./Footer";
import SEO from "./SEO";

export default function Layout({
  children,
  title,
}: {
  children: React.ReactNode;
  title?: string;
}) {
  return (
    <div className="flex min-h-screen flex-col">
      <SEO title={title} />
      {children}
      <Footer />
    </div>
  );
}
